import { render, staticRenderFns } from "./RemarksBox.vue?vue&type=template&id=32e968f0&scoped=true&"
import script from "./RemarksBox.vue?vue&type=script&lang=js&"
export * from "./RemarksBox.vue?vue&type=script&lang=js&"
import style0 from "./RemarksBox.vue?vue&type=style&index=0&id=32e968f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e968f0",
  null
  
)

export default component.exports